export default "__VITE_ASSET__CttA_drg__"